import { render } from "./PlatformSubscriptionCardForm.vue?vue&type=template&id=3f4134d6&scoped=true"
import script from "./PlatformSubscriptionCardForm.vue?vue&type=script&lang=js"
export * from "./PlatformSubscriptionCardForm.vue?vue&type=script&lang=js"

import "./PlatformSubscriptionCardForm.vue?vue&type=style&index=0&id=3f4134d6&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f4134d6"]])

export default __exports__